import { Warning } from '@mui/icons-material';
import { Box, Paper, Switch, Typography } from '@mui/material';
import { Field, useField } from 'formik';

import { ApprovalMode } from 'openapi';

import { useTranslations } from 'context/TranslationContext';

import {
  ruleFormContentStyle,
  ruleFormHeaderStyle,
  ruleStepIndicatorStyle,
  exclusiveAlertContentStyle
} from 'styles/pages/ApprovalRuleFormStyle';

export interface RuleOptionsSectionProps {
  selectedMode?: ApprovalMode;
}

export const RuleOptionsSection = ({
  selectedMode
}: RuleOptionsSectionProps) => {
  const { translate } = useTranslations();
  const [{ value: exclusive }] = useField('exclusive');

  const isExclusiveDisabled = selectedMode === ApprovalMode.AUTO_APPROVE;

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '1rem',
        border: '1px solid #e5e7eb',
        marginBottom: 0
      }}
    >
      <Box sx={ruleFormHeaderStyle}>
        <Box sx={ruleStepIndicatorStyle}>4</Box>
        <Typography
          variant="body1"
          sx={{
            fontSize: '0.75rem',
            fontWeight: 600
          }}
        >
          {translate('approvals.options')}
        </Typography>
      </Box>
      <Box sx={ruleFormContentStyle}>
        <Box display="flex" flexDirection="column" gap="0.25rem">
          <Field name="exclusive" type="checkbox">
            {({ field }: { field: any }) => (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.25rem'
                }}
              >
                <Switch {...field} disabled={isExclusiveDisabled} />
                <Typography variant="body2">
                  {translate('approvals.exclusive')}
                </Typography>
                <Typography variant="body2" sx={{ color: '#6b7280' }}>
                  - {translate('approvals.exclusiveHelp')}
                </Typography>
              </Box>
            )}
          </Field>
          {exclusive && (
            <Box sx={exclusiveAlertContentStyle}>
              <Warning sx={{ color: '#ed6c02' }} />
              <Typography
                variant="body2"
                sx={{
                  color: '#663c00',
                  margin: '12px 0'
                }}
              >
                {translate('approvals.exclusiveWarning')}
              </Typography>
            </Box>
          )}
        </Box>
        <Field name="active" type="checkbox">
          {({ field }: { field: any }) => (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem'
              }}
            >
              <Switch {...field} />
              <Typography variant="body2">
                {translate('labels.active')}
              </Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                - {translate('approvals.activeHelp')}
              </Typography>
            </Box>
          )}
        </Field>
      </Box>
    </Paper>
  );
};
